export { default } from './ContentCredentialPopover';
